export default __webpack_public_path__ + "static/media/ecommerce.6e23b2ae.png";